<template>
  <v-autocomplete
    :model-value="normalizedModelValue"
    :items="options"
    item-title="label"
    item-value="id"
    :label="$t('ncrm.activity.fields.assignee')"
    :loading="loading"
    :disabled="disabled"
    :menu-props="menuProps"
    @update:model-value="updateValue"
  />
</template>

<script>
import axios from "axios";

const parsePositiveId = (value) => {
  const parsed = Number(value);
  return Number.isFinite(parsed) && parsed > 0 ? Math.trunc(parsed) : null;
};

const normalizeOption = (value = {}) => {
  const id = parsePositiveId(value?.id);
  if (!id) return null;
  const displayName = String(value?.display_name ?? value?.displayName ?? "").trim();
  const name = String(value?.name ?? "").trim();
  const email = String(value?.email ?? "").trim();
  return {
    id,
    label: displayName || name || email || `#${id}`,
  };
};

export default {
  name: "NcrmActivityAssigneeField",
  props: {
    modelValue: {
      type: [Number, String],
      default: null,
    },
    disabled: {
      type: Boolean,
      default: false,
    },
    menuProps: {
      type: Object,
      default: () => ({}),
    },
  },
  emits: ["update:modelValue"],
  data() {
    return {
      loading: false,
      options: [],
    };
  },
  computed: {
    normalizedModelValue() {
      return parsePositiveId(this.modelValue);
    },
  },
  mounted() {
    this.loadOptions();
  },
  methods: {
    updateValue(value) {
      this.$emit("update:modelValue", parsePositiveId(value));
    },
    async loadOptions() {
      this.loading = true;
      try {
        const { data } = await axios.get("/ncrm/activity/owners", {
          params: { limit: 200 },
        });
        this.options = (Array.isArray(data?.items) ? data.items : [])
          .map((item) => normalizeOption(item))
          .filter(Boolean);
      } catch (error) {
        console.error("[ncrm] load activity assignees failed:", error);
        this.options = [];
      } finally {
        this.ensureSelectedOption();
        this.loading = false;
      }
    },
    ensureSelectedOption() {
      const selectedId = this.normalizedModelValue;
      if (!selectedId || this.options.some((item) => item.id === selectedId)) return;
      this.options = [{ id: selectedId, label: `#${selectedId}` }, ...this.options];
    },
  },
  watch: {
    normalizedModelValue() {
      this.ensureSelectedOption();
    },
  },
};
</script>
